<template>
  <aside class="customizer" :class="{ 'show-service-panel': open }">
    <a
      href="javascript:void(0)"
      class="service-panel-toggle"
      :class="{ 'bg-danger': isWarning }"
      @click="open = !open"
    >
      <i class="fas fa-thermometer-empty" v-if="!isWarning"></i>
      <i class="fas fa-thermometer-full" v-if="isWarning"></i>
    </a>
    <div
      class="customizer-body ps-container ps-theme-default"
      data-ps-id="03778fae-78de-8769-9787-397a69928f62"
    >
      <ul id="requestControl" v-if="isDevelopment">
        <li
          v-for="item in Object.entries(requestWatch).sort((x, y) => {
            return y[1].requests.length - x[1].requests.length;
          })"
          :key="item[0]"
          :title="item[0]"
        >
          <span>
            <span class="badge bg-info w100">
              {{ item[1].requests.length }}
            </span>
          </span>
          <span>
            <span class="url">
              {{
                item[0].replace("https://api.kolayrez.com/", "")
              }}</span
            >
          </span>
          <span>
            <span
              class="badge w100"
              v-if="item[1].diffTime != null"
              :class="{
                'bg-success': Math.round(item[1].diffTime) >= 5,
                'bg-danger': Math.round(item[1].diffTime) < 5,
              }"
            >
              <template v-if="Math.round(item[1].diffTime) < 60">
                {{ Math.round(item[1].diffTime) }}sn
              </template>
              <template
                v-if="
                  Math.round(item[1].diffTime) > 59 &&
                    Math.round(item[1].diffTime) < 3600
                "
              >
                {{ Math.round(item[1].diffTime / 60) }}dk
              </template>
              <template v-if="Math.round(item[1].diffTime) > 3599">
                {{ Math.round(item[1].diffTime / 60 / 60) }}s
              </template>
            </span>
          </span>
          <!-- <ul>
            <li
              v-for="request in item[1].requests"
              :key="item[0] + request.date"
            >
              {{ $moment(request.date).format("HH:mm:ss") }}
            </li>
          </ul> -->
        </li>
      </ul>
      <button
        class="btn btn-success w100"
        style="border-radius: 0;"
        @click="$store._state.data.requestWatch = {}"
      >
        Clear
      </button>
    </div>
  </aside>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "projectMonitoring",
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapState(["requestWatch"]),
    isDevelopment() {
      return process.env.NODE_ENV == "development";
    },
    isWarning() {
      let isDiff = null;
      Object.entries(this.requestWatch).forEach((element) => {
        if (
          element[1].diffTime != null &&
          (isDiff == null || isDiff > element[1].diffTime)
        ) {
          isDiff = element[1].diffTime;
        }
      });
      // if ((isDiff == null ? false : isDiff < 5 ? true : false) == true) {
      //   this.$swal({
      //     icon: "error",
      //     title: "Danger",
      //     text: "Çok sık request atıyorsun!",
      //     confirmButtonText: "Okey",
      //   });
      // }
      return isDiff == null ? false : isDiff < 5 ? true : false;
    },
  },
};
</script>
